export default __webpack_public_path__ + "82270fda927a02acf537221f8f96c3a7.png";